import {createSlice} from '@reduxjs/toolkit'
import {ROUTE_PATH} from '../../app/constants'

const confirmBeforePaymentSlice = createSlice({
        name : "confirmBeforePayment",
        initialState : {
            header : "Confirmation",
            text : [
                "I confirm the information presented to be correct to the best of my knowledge, " +
                "I agree to abide by the Acts and Regulations governing the Licence/Registration " +
                "being applied for, and authorize Service Nova Scotia and Internal Services to " +
                "verify information given or applied as part of this application with the " +
                "appropriate resources."
            ],
            navigation : {
                next : ROUTE_PATH.PAYMENT_PREVIEW
            }
        },
        reducers : {}
    }
)

export default confirmBeforePaymentSlice.reducer
